import { BASE_URL, COMPANY_DEPARTMENT, COMPANY_TOPIC } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ICompanyDepartmentsInput, ICompanyDepartmentsInputEdit } from "models/companyDepartment";
import { ICompanyTopic, ICompanyTopicInput,  } from "models/companyTopics";


export async function getCompanyTopics(params: string = ""): Promise<ICompanyTopic[]> {
  const response = await axios.get(BASE_URL + COMPANY_TOPIC + params);
  return response.data;
}
export async function addCompanyTopics(data: ICompanyTopicInput[]) {
  const response = await axios.post(BASE_URL + COMPANY_TOPIC, data);
  return response.data;
}

export async function editCompanyTopic(data: ICompanyTopicInput,id:string) {
  const response = await axios.patch(BASE_URL + COMPANY_TOPIC+"/"+id, data);
  return response.data;
}

export async function deleteCompanyTopic(id: string) {
  const response = await axios.delete(BASE_URL + COMPANY_TOPIC + "/" + id);
  return response.data;
}

export const CompanyTopicsCells: HeadCell[] = [

  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
 
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
